import React from "react";

export default function SessionsToolbar({
  search,
  onSearchChange,
  statusFilter,
  onStatusFilterChange,
  severityFilter,
  onSeverityFilterChange,
  patientFilter,
  onPatientFilterChange,
  patients,
  showAll,
  onToggleShowAll,
  onNewSession,
  disableActions = false,
}) {
  return (
    <div className="mgsessions-toolbar">
      <div className="mgsessions-toolbar-filters">
        <input
          className="mgsessions-filter-input"
          type="text"
          placeholder="Search sessions"
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          disabled={disableActions}
        />

        <select
          className="mgsessions-filter-select"
          value={statusFilter}
          onChange={(e) => onStatusFilterChange(e.target.value)}
          disabled={disableActions}
        >
          <option value="all">All statuses</option>
          <option value="draft">Draft</option>
          <option value="completed">Completed</option>
          <option value="reviewed">Reviewed</option>
          <option value="closed">Closed</option>
        </select>

        <select
          className="mgsessions-filter-select"
          value={severityFilter}
          onChange={(e) => onSeverityFilterChange(e.target.value)}
          disabled={disableActions}
        >
          <option value="all">All severity</option>
          <option value="critical">Critical</option>
          <option value="high">High</option>
          <option value="moderate">Moderate</option>
          <option value="low">Low</option>
          <option value="untriaged">Untriaged</option>
        </select>

        <select
          className="mgsessions-filter-select"
          value={patientFilter}
          onChange={(e) => onPatientFilterChange(e.target.value)}
          disabled={disableActions}
        >
          <option value="all">All patients</option>
          {patients.map((patient) => (
            <option key={patient.id} value={String(patient.id)}>
              {patient.name}
            </option>
          ))}
        </select>
      </div>

      <div className="mgsessions-toolbar-actions">
        <button
          className="mgsessions-btn ghost"
          type="button"
          onClick={onToggleShowAll}
          disabled={disableActions}
        >
          {showAll ? "Show less" : "See all"}
        </button>

        <button
          className="mgsessions-btn primary"
          type="button"
          onClick={onNewSession}
          disabled={disableActions}
        >
          New Session
        </button>
      </div>
    </div>
  );
}